import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { FieldWrapper, MainfieldWrapper } from '../../common-field-styles';
import { assignFormDesignToCSSVars } from '../fields-customise.style';
import { FormContext } from '../../../shared/contexts/form-context';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import Header from './section-header.styled';

const MediaHeader = ({ ctrl, formDesign }) => {
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];
  const { inBuilder } = useContext(FormContext);
  
  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper notInBuilder={!inBuilder}>
        <Header
          dangerouslySetInnerHTML={{ __html: fieldLabel }}
          alignment={ctrl.props.text_alignment}
          id={`fpl-${ctrl.internal_id}`}
          divider={ctrl.props.divider}
        />
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

MediaHeader.defaultProps = {
  formDesign: null,
};

MediaHeader.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};

export default MediaHeader;
